(function() {
  
  const productConfig = {
    'product-1-new': {
      variantId: '42432408584227',
      prices: {
        oneTime: { 
          product: '$44.95', 
          total: '$15.00', 
          free: '$44.95' 
        },
        subscription: { 
          product: '$33.71', 
          total: '$26.24', 
          free: '$33.71' 
        }
      }
    },
    'product-2-new': {
      variantId: '42432408616995',
      prices: {
        oneTime: { 
          product: '$69.90', 
          total: '$50.00', 
          free: '$34.95' 
        },
        subscription: { 
          product: '$52.43', 
          total: '$67.47', 
          free: '$26.21' 
        }
      }
    },
    'product-3-new': {
      variantId: '42432408649763',
      prices: {
        oneTime: { 
          product: '$99.00', 
          total: '$80.85', 
          free: '$33.00' 
        },
        subscription: { 
          product: '$74.25', 
          total: '$105.60', 
          free: '$24.75' 
        }
      }
    },
    'product-4-new': {
      variantId: '42432408682531',
      prices: {
        oneTime: { 
          product: '$119.85', 
          total: '$119.95', 
          free: '$29.96' 
        },
        subscription: { 
          product: '$89.89', 
          total: '$149.91', 
          free: '$22.47' 
        }
      }
    }
  };

  function setupProductRadios(productKey) {
    const config = productConfig[productKey];
    const planData = window.SellingPlanMatcher.getPlanForVariant(config.variantId);
    
    if (!planData) {
      console.warn(`${productKey}: No subscription available`);
      $(`#${productKey} input[value="2"]`).prop('disabled', true).parent().hide();
    } else {
      console.log(`✅ ${productKey}: Subscription enabled with "${planData.subscriptionPlanName}"`);
    }
    
    $(`#${productKey} input[type="radio"]`).change(function () {
      if (this.checked) {
        $(`#${productKey} input[type="radio"]`).not(this).prop('checked', false);
        var val = $(this).val();

        if (val == 1) { 
          $(`#${productKey} .product-notice`).hide();
          $(`#${productKey} .delivery`).hide();
          $(`#${productKey} .product-price`).text(config.prices.oneTime.product);
          $(`#${productKey} .total-price span`).text(config.prices.oneTime.total);
          $(`#${productKey} .product-free span`).text(config.prices.oneTime.free);
          
          const url = window.SellingPlanMatcher.buildCartUrl(config.variantId, 1);
          $(`#${productKey} .btn-cart`).attr('href', url);
          
        } else if (val == 2) { 
          $(`#${productKey} .product-notice`).show();
          $(`#${productKey} .delivery`).show();
          $(`#${productKey} .product-price`).text(config.prices.subscription.product);
          $(`#${productKey} .total-price span`).text(config.prices.subscription.total);
          $(`#${productKey} .product-free span`).text(config.prices.subscription.free);
          
          const url = window.SellingPlanMatcher.buildCartUrl(
            config.variantId, 
            1, 
            planData ? planData.subscriptionPlanId : null
          );
          $(`#${productKey} .btn-cart`).attr('href', url);
        }
      }
    });
  }

  $(document).ready(function () {
    setupProductRadios('product-1-new');
    setupProductRadios('product-2-new');
    setupProductRadios('product-3-new');
    setupProductRadios('product-4-new');
  });

})();